<p>sale-doc-self-checkout-base works!</p>
